import React from 'react';

import { Header } from './Header';

const Layout = ({
  leftSideMenu,
  onLoginClick,
  isLoggedIn,
  displayName,
  onLogoutClick,
  isAuthorizing,
  ...props
}) => {
  return (
    <div className="agora-app-all-but-footer">
      <Header
        onLoginClick={onLoginClick}
        displayName={displayName}
        onLogoutClick={onLogoutClick}
        isLoggedIn={isLoggedIn}
        isAuthorizing={isAuthorizing}
      />
      <div className="agora-app-all-pages">
        {leftSideMenu ? (
          <div className="agora-app-left-menu-layout-container">
            <div className="agora-app-left-side-menu">{leftSideMenu}</div>
            <div className="agora-app-right-side-content">{props.children}</div>
          </div>
        ) : (
          <div className="agora-app-full-page-content">{props.children}</div>
        )}
      </div>
    </div>
  );
};

export { Layout };
